module.exports = __webpack_public_path__ + "static/img/abc.76cec200.png";